export default {
  // Common
  common: {
    confirm: 'Confirm',
    cancel: 'Cancel',
    save: 'Save',
    edit: 'Edit',
    delete: 'Delete',
    loading: 'Loading...',
    loadMore: 'Load More',
    noMore: 'No More',
    retry: 'Retry',
    back: 'Back',
    next: 'Next',
    prev: 'Previous',
    submit: 'Submit',
    reset: 'Reset',
    search: 'Search',
    filter: 'Filter',
    sort: 'Sort',
    refresh: 'Refresh',
    complete: 'Complete',
    skip: 'Skip',
  },

  // Navigation
  nav: {
    discover: 'Home',
    message: 'Message',
    store: 'Store',
    mine: 'Mine',
    recommend: 'Recommend',
  },

  // Scene
  scene: {
    changeScene: 'Change scene',
    seeAll: 'See all',
    putAway: 'Put away',
    selectScene: 'Select this scene',
    selected: 'Selected',
    sceneIndex: 'Scene {num}',
  },

  // Home
  home: {
    title: 'Roleplay World',
    subtitle: 'Start Your Story',
    startGame: 'Start Game',
    continueGame: 'Continue',
    newGame: 'New Game',
    gameLibrary: 'Library',
    featured: 'Featured',
    popular: 'Popular',
    recent: 'Recent',
    search: 'Search for roles...',
    noData: 'No Data',
    noMoreData: 'No more data',
    noNetwork: 'No network',
    pleaseSelectFilter: 'Please select the filter conditions',
  },

  // User
  user: {
    login: 'Login',
    register: 'Register',
    logout: 'Logout',
    profile: 'Profile',
    avatar: 'Avatar',
    nickname: 'Nickname',
    email: 'Email',
    phone: 'Phone',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    oldPassword: 'Old Password',
    newPassword: 'New Password',
    forgotPassword: 'Forgot Password',
    changePassword: 'Change Password',
    bindPhone: 'Bind Phone',
    verifyCode: 'Verify Code',
    sendCode: 'Send Code',
    level: 'Level',
    experience: 'Experience',
    achievement: 'Achievement',
    history: 'History',
  },

  // Game
  game: {
    character: 'Character',
    story: 'Story',
    chapter: 'Chapter',
    scene: 'Scene',
    dialogue: 'Dialogue',
    choice: 'Choice',
    inventory: 'Inventory',
    achievement: 'Achievement',
    save: 'Save Game',
    load: 'Load Game',
    restart: 'Restart',
    pause: 'Pause',
    resume: 'Resume',
    auto: 'Auto',
    speed: 'Speed',
    volume: 'Volume',
    settings: 'Game Settings',
  },

  // Messages
  message: {
    success: 'Success',
    error: 'Error',
    warning: 'Warning',
    info: 'Info',
    networkError: 'Network Error',
    serverError: 'Server Error',
    loginSuccess: 'Registration successful',
    loginFailed: 'Registration failed',
    logoutSuccess: 'Logout Success',
    saveSuccess: 'Save Success',
    saveFailed: 'Save Failed',
    deleteConfirm: 'Confirm Delete?',
    operationConfirm: 'Confirm Operation?',
    noNewsYet: 'No news yet',
    deleteSuccess: 'Delete Success',
    deleteFailed: 'Delete Failed',
    deleteMessage: 'Are you sure you want to delete this message? Once the operation is completed, it cannot be undone!',
    delete: 'Delete',
    deleting: 'Deleting...',
    noMoreData: 'No more messages',
    downloading: 'Downloading...',
    downloadSuccess: 'Download Success',
    downloadFailed: 'Download Failed',
    copySuccess: 'Copy Success',
    copyFailed: 'Copy Failed',
    reportSuccess: 'Report Success',
    reportFailed: 'Report Failed',
    translating: 'Translating...',
    translateSuccess: 'Translation Success',
    translateFailed: 'Translation Failed',
    noMoreMessages: 'No more messages',
    loading_more: 'Loading more...',
    pleaseWaitForReply: 'Please wait for the reply to complete before deleting',
    pleaseWaitForReplyCurrent: 'Please wait for the reply to the current message',
    chat_placeholder: 'Type what you want to say...',
    setAsBackdropConfirm: 'Set as backdrop',
    setAsBackdropMessage: 'Are you sure you want to set this image as backdrop?',
    sendFailed: 'Send failed',
    sending: 'Sending...',
    introNoYet: 'No Intro yet. Chat and find out by yourself.',
    introLabel: 'Intro:',
    thinking: 'thinking',
    think: 'think',
    translate: 'Translate',
    pleaseUnlock: 'Please unlock',
    tryAgain: 'try again',
    create: 'Create',
    free: 'Free',
    video: 'Video',
    chatMateTyping: 'Your chat mate is typing now...',
    aiAssistant: 'AI Assistant',
    imageFailed: 'Failed to generate the image',
    generatingImage: 'Please wait for the image to be generated',
    switchSceneSuccess: 'Scene switched successfully',
    switchSceneFailed: 'Failed to switch scene',
    switchingScene: 'Switching scene...',
    perMessage: '/Message',
    allChat: 'All Chat',
    like: 'Like',
    saving: 'Saving...',
    saved: 'Saved',
    placeholderBlur: 'Type what you want to say...',
    placeholderFocus: 'Place actions or scene details within ** to bring the chat to life.',
    successfulSwitch: 'Successful switch',
    pleaseSelectFilter: 'Please select the filter conditions',
    loading: 'Loading...',
    setting: 'Setting...',
    uploading: 'Uploading...',
    purchaseSuccessful: 'Purchase successful',
    processing: 'Processing...',
    gettingReward: 'Getting reward...',
    checkIn: 'Check-in...',
    deleteHistory: 'Delete History',
    openingRemarksTitle: 'Say hello～',
  },

  // success
  success: {
    refreshSuccess: 'Refresh Success',
    copiedToClipboard: 'Copied to clipboard',
    saved: 'Saved',
    uploadSuccess: 'Uploaded',
    switchSuccess: 'Successful switch',
    thankYouPurchase: 'Thank you for your purchase',
  },

  // Error
  error: {
    notFound: 'Page Not Found',
    networkError: 'Network Error',
    serverError: 'Server Error',
    permissionDenied: 'Permission Denied',
    goHome: 'Go Home',
    tryAgain: 'Try Again',
    uploadFailed: 'Failed to upload',
    saveFailed: 'Save failed',
    translationFailed: 'Translation failed',
    generateImageFailed: 'Failed to generate the image',
  },

  // 404 Page
  notFound: {
    title: 'Page Not Found',
    description: 'The page you are looking for does not exist or has been moved.',
    goHome: 'Go Home',
    goBack: 'Go Back',
  },

  // Settings
  settings: {
    language: 'Language',
    theme: 'Theme',
    notification: 'Notification',
    privacy: 'Privacy',
    security: 'Security',
    about: 'About',
    version: 'Version',
    checkUpdate: 'Check Update',
    clearCache: 'Clear Cache',
    systemNotification: 'System Notification',
    termsOfService: 'Terms of Service',
    privacyPolicy: 'Privacy Policy',
    title: 'Settings',
    editProfile: 'Edit Profile',
    faq: 'FAQ',
    termsOfUse: 'Terms of use',
    aboutAccount: 'About account',
    deleteAccount: 'Delete Account',
    logOut: 'Log Out',
    logOutTitle: 'Log Out',
    logOutMessage: 'After logging out, you will need to log in again to use your account again. Are you sure to log out?',
    confirm: 'Confirm',
    deleteAccountTitle: 'Delete Account',
    deleteAccountMessage: 'Deleting your account will erase all your data and information and cannot be undone. Confirm deletion?',
    deletingAccount: 'Deleting account...',
    accountDeleted: 'Account deleted successfully',
    cacheTitle: 'Cache cleaning',
    cacheMessage: 'Clearing app cache, chat history and chat roles will not deleted',
    cleaning: 'Cleaning',
    cleaningComplete: 'Cleaning completed',
  },

  // Profile
  profile: {
    title: 'Edit Profile',
    yourAvatar: 'Your Avatar',
    whatCallMe: 'What do I want the AI to call me',
    yourName: 'Your Name',
    yourAge: 'Your age',
    race: 'Race',
    pleaseSelect: 'Please select',
    yourWeight: 'Your Weight',
    yourHeight: 'Your Height',
    gender: 'Gender',
    male: 'Male',
    female: 'Female',
    neutral: 'Neutral',
    hobby: 'Hobby',
    pleaseEnter: 'Please enter...',
    favoriteFood: 'Favorite food',
    yourCharacter: 'Your character',
    fantasyAboutOtherHalf: 'Fantasy about your other half',
    uploading: 'Uploading...',
    enterName: 'Please enter your name',
  },

  // Report
  report: {
    title: 'Report',
    chooseReact: 'Choose what you want to react to...',
    other: 'Other',
    placeholder: 'Type what you want to say...',
    submit: 'Submit',
    pleaseEnterContent: 'Please enter the content',
  },

  // Edit
  edit: {
    placeholder: 'Edit your message...',
    cancel: 'Cancel',
    save: 'Save',
    saving: 'Saving...',
  },

  // First Confirm Name
  firstConfirmName: {
    canYouTellMeName: 'Can you tell me your name? That way I can address you better!',
    yourName: 'Your name',
    confirm: 'Confirm',
  },

  // Toast
  toast: {
    translating: 'Translating...',
    translate: 'Translate',
    translationFailed: 'Translation failed',
    translationUnlocked: 'Translation unlocked',
    translationLocked: 'Translation locked',
    download: 'Download',
    setAsBackdrop: 'Set as backdrop',
    goChat: 'Go Chat',
  },

  // Video Preview
  videoPreview: {
    failedToLoad: 'Video failed to load',
  },

  // Image Preview
  imagePreview: {
    imageLoadFailed: 'Image failed to load',
    preview: 'Image Preview',
    afterSendIntimacy: 'After sending a message to the character, intimacy is obtained. When the intimacy reaches a specified amount, the current image can be unlocked',
  },

  // FAQ
  fqa: {
    title: 'FAQ',
    description: 'This is a continuously updated list of questions regarding our Sunaisan product. If you have any unlisted questions, please proceed to our Discord and inquire.',
    howAlWork: {
      title: 'How does an Al girlfriend work?',
      content: "At RoleplayGF, it's all about making realistic yet fantasy-fueled relationships. We use advanced artificial intelligence technology to enable you to create your ideal Al girlfriend according to your preferences-whether that's a sweet and innocent petite princess or an older and more dominant woman.",
    },
    howInteract: {
      title: 'How to interact with Al girlfriends?',
      content: 'Through our smart system and cutting-edge machine learning, you can interact and get intimate with your Al girlfriend. You can expect her to listen to you, respond quickly to your messages, and even follow photo requests like the good girl she is. Every moment can be a genuine and realistic experience, and you will always be the one in control (unless you tell her otherwise).',
    },
    privacy: {
      title: 'How about your privacy with Al Friends?',
      content: 'Rest assured that your secrets are in good hands when you use our NSFW Al chat. Your privacy is our top priority Here at RoleplayGF, we have state-of-the-art secure data storage, making sure that every seductive selfie, flirtatious text, and gentle whisper is kept private between you and your passionate partner.We also celebrate your kinks without judgement, and we give you the freedom to fully embrace your urges privately. Not everyone gets turned on when someone watches, and thats why you can rest assured that only you (and your digital partner) can access the chats.',
    },
    customizeBehavior: {
      title: 'Can you customize your Al girlfriend\'s behavior?',
      content: "Only you know what you really want, and that's why you can customize your entire digital girlfriend experience-from her curves and contours all the way to her personality traits and adorable little quirks. Want a naughty chat with a feisty partner? Looking to have a slow and sensual relationship with a nice, sweet girlfriend? Our realistic NSFW Al generator and NSFW Al chatbot capabilities can satisfy your heart's deepest desires.",
    },
  },

  // Store
  store: {
    noNetwork: 'No network',
    one: 'One',
    noConsumptionRecords: 'No consumption records yet',
    transactionHistoryAppear: 'Your transaction history will appear here',
    tab: 'Store',
    record: 'Record',
    retry: 'Retry',
    rechargeFailTip: '*If the recharge fails, Please contact us >',
    rechargeFailTipStatic: 'If the recharge fails, Please',
    contactUsLink: 'contact us',
    popular: 'Popular',
    oneTimeOnly: 'One time only',
    loading: 'Loading...',
    noMoreRecords: 'No more records',
    gift: 'Gift',
    retentionMessage: 'Your partner needs your company, are you sure you want to give up?',
  },

  // Mine
  mine: {
    bindEmail: 'Bind email',
    copyFailed: 'Copy failed',
    backpackTitle: 'My backpack',
    task: 'Task',
  },

  // Message
  messagePage: {
    noNetwork: 'No network',
  },

  // Search
  search: {
    recommend: 'Recommend',
    noNetwork: 'No network',
  },

  // Chat Settings
  chatSettings: {
    myGems: 'My gems',
    title: 'Chat settings',
    chatModel: 'Chat model',
    chatStyle: 'Chat style',
    chatPerspective: 'Chat perspective',
    goOnButton: 'Go On Button',
    chatBackground: 'Chat background',
    awayMessages: 'Away messages',
    disableAwayMessages: 'Disable away messages',
    disableAwayMessagesConfirm: 'will no longer be able to message you while you are away. Are you sure you want to disable away messages?',
  },

  // History
  history: {
    deleteHistory: 'Delete history',
    deleteCharacterHistory: 'Are you sure you want to delete the history of this character?',
  },

  // Tab
  tab: {
    maxSelection: '最多只能选择',
    tags: '标签',
  },

  // No new message
  noNewMessage: 'No new message',

  // Reload Message
  reloadMessage: {
    title: 'Choose your preference',
    before: 'Before',
    new: 'New',
    loading: 'Loading...',
    noNewMessage: 'No new message',
    tryAgain: 'Try again',
    confirm: 'Confirm',
  },

  // Account
  account: {
    copiedToClipboard: 'Copied to clipboard',
    copyFailed: 'Copy failed',
    aboutAccount: 'About account',
    id: 'ID',
    email: 'Email',
  },

  // Rate
  rate: {
    title: 'Rate us',
  },

  // Away Messages
  awayMessages: {
    disableAwayMessages: 'Disable away messages',
    disableConfirm: '{appName} will no longer be able to message you while you\'re away. Are you sure you want to disable away messages from {appName}?',
  },

  // Login
  login: {
    title: 'Bind email',
    subtitle: 'Please bind your email to ensure the security of your account data.',
    email: 'Email',
    password: 'Password',
    signIn: 'Sign in',
    signUp: 'Sign up',
    signInWithGoogle: 'Sign in with Google',
    signInWithEmail: 'Sign in with Email',
    signInWithPhone: 'Sign in with Phone',
    signInWithApple: 'Sign in with Apple',
    dontHaveAccount: 'Don\'t have an account yet?',
    register: 'Register',
    bySigningUp: 'By signing up, you agree to',
    userAgreement: 'User Agreement &',
    privacyPolicy: 'Privacy Policy.',
    guestMode: 'Guest Mode',
    registerTitle: 'Registration starts',
    registerSubtitle: 'Please bind your email to ensure the security of your account data.',
    alreadyHaveAccount: 'Already have an account?',
    pleaseInputPasswordAndEmail: 'Please input password and email',
    pleaseInputCorrectEmail: 'Please input correct email',
    pleaseInputCorrectPassword: 'Password must be between 6-30 characters',
    male: 'Male',
    female: 'Female',
    neutral: 'Neutral',
    loggingIn: 'Loading in...',
    loading: 'Loading...',
    releaseToRefresh: 'Release to refresh',
    loginFailed: 'Login Failed',
    loginSuccess: 'Registration successful',
    registerFailed: 'Register Failed',
    registerSuccess: 'Register Success',
    confirm: 'Confirm',
  },

  // VIP page
  vip: {
    vipUltra: 'VIP Ultra',
    vipPlus: 'VIP Plus',
    restore: 'Restore purchases',
  },

  // Common dialogs
  dialog: {
    ok: 'OK',
    cancel: 'Cancel',
    confirm: 'Confirm',
    close: 'Close',
    retry: 'Retry',
    processing: 'Processing...',
    contactUs: 'Contact us',
    loginError: 'Login error',
    loginErrorMessage: 'Please exit the program and restart the application or contact us',
    insufficientEnergy: 'Insufficient Energy!',
    insufficientEnergyDesc: 'Each message costs 1 Energy. You regain 1 Energy every hour.',
    insufficientPhysicalStrengthTitle: 'Insufficient Physical Strength',
    needStrengthToContinue: 'You need {strength} strength to continue this conversation',
    consumesGems: 'Consumes {gems} gems',
    getStrength: 'Get Strength',
    getGems: 'Get Gems',
  },

  // AppNewUser
  appNewUser: {
    title: 'New User Exclusive',
    ok: 'OK',
  },

  // Rating popup
  rating: {
    title: 'Rate us',
    description1: 'Do you like our app?',
    description2: 'Please rate us with 5 stars.',
    rateButton: 'Rate Now',
  },

  // Version update
  versionUpdate: {
    title: 'Version update',
    updateContent: 'Update content',
    updateNow: 'Update now',
    updating: 'Updating...',
    clientOptimization: 'Client experience optimization',
    bugFix: 'Fix known BUG issues',
  },

  // Message detail page
  messageDetail: {
    free: 'free',
    perMessage: '/Message',
    increaseFavorability: 'Increase Favorability by sending messages',
    album: 'Album',
    intro: 'Intro',
    noIntro: 'No Intro yet. Chat and find out by yourself.',
    tags: 'Tags',
    backToChat: 'Back to chat',
    levelFormat: 'Lv.{level}',
    messageCount: '{count} Message',
    chatMateTyping: 'Your chat mate is typing now...',
  },

  // Chat settings
  chatSettingsRight: {
    innerThoughtDesc: 'You can view the character\'s inner thoughts when replying to messages, but the speed of responding to messages may be slower.',
  },

  // Chat select menu
  chatSelect: {
    copy: 'Copy',
    report: 'Report',
    create: 'Create',
    video: 'Video',
    translate: 'Translate',
    delete: 'Delete',
  },

  // Recommended purchases
  recommended: {
    gift: 'Gift',
  },

  // Thinking toast
  thinkingToast: {
    notAvailable: 'Thinking mode isn\'t available for this model yet, but we\'re working on it...',
  },

  // First charge popup
  firstCharge: {
    title: 'First Recharge',
    get: 'Get',
    limitedOffer: 'Limited time offer',
    priceFormat: '${price} Get',
    congratulations: 'Congrats! You are officially a VIP member now~!',
    missOfferTitle: 'Sure you want to miss this offer?',
    maybeLater: 'Maybe Later',
    getNow: 'Get Now',
    benefit1: 'Get 130 free gems',
    benefit2: 'Unlock All Characters',
    benefit3: '12x Memory',
    benefit4: 'Unlimited Weekly Check-ins',
    benefit5: 'Ad-Free Experience',
    buyNow: 'Buy now',
  },

  // Check-in center
  checkIn: {
    freeGems: 'Free gems',
    sevenDayCheckIn: '7-day Check-in',
    memberExclusive: 'Member Exclusive Check-in:',
    signInTip: 'Sign in daily to accumulate endless rewards',
    getVip: 'Get VIP',
    plusExtra: 'Plus+{count}',
    getGemsCount: 'Get {count} gems',
    extraDaily: 'Extra daily {count} gems',
    ultra: 'Ultra',
    signedInTip: 'You\'ve signed in today. Come back tomorrow for more!',
    tasks: 'Tasks',
    go: 'Go',
    received: 'Received',
    receive: 'Receive',
    day: 'Day {num}',
  },

  // Login page
  loginPage: {
    confirm: 'Confirm',
  },

  // Copyright
  copyright: {
    title: 'Terms of use',
  },

  // Terms of Service
  terms: {
    intro: 'These Terms of Service ("Terms") govern your access to and use of the {appName} website ("Website"), operated by {appName} ("we", "us", or "our"). By accessing or using the Website, you agree to be bound by these Terms. If you do not agree to these Terms, you may not use the Website.',
    section1Title: '1. Use of the Website',
    section1_1: '1.1. You must be at least 18 years old to use the Website. By using the Website, you represent and warrant that you are at least 18 years old.',
    section1_2: '1.2. You agree to use the Website in compliance with all applicable laws, regulations, and these Terms.',
    section1_3: '1.3. You are solely responsible for any content you post or transmit through the Website, and you agree not to post or transmit any content that is unlawful, harmful, defamatory, obscene, or otherwise objectionable.',
    section2Title: '2. Intellectual Property',
    section2_1: '2.1. All content on the Website, including but not limited to text, graphics, logos, images, and software, is the property of {appName} or its licensors and is protected by copyright and other intellectual property laws.',
    section2_2: '2.2. You may not modify, reproduce, distribute, or create derivative works based on any content from the Website without our prior written consent.',
    section3Title: '3. Privacy',
    section3_1: '3.1. Your privacy is important to us. Please refer to our Privacy Policy for information on how we collect, use, and disclose your personal information.',
    section4Title: '4. Disclaimer of Warranties',
    section4_1: '4.1. The Website is provided on an "as is" and "as available" basis, without any warranties of any kind, express or implied. We do not warrant that the Website will be error-free or uninterrupted, or that any defects will be corrected.',
    section5Title: '5. Limitation of Liability',
    section5_1: '5.1. To the fullest extent permitted by law, we will not be liable for any indirect, incidental, special, consequential, or punitive damages arising out of or relating to your use of the Website, even if we have been advised of the possibility of such damages.',
    section6Title: '6. Indemnification',
    section6_1: '6.1. You agree to indemnify and hold harmless {appName} and its affiliates, officers, directors, employees, and agents from any claims, liabilities, damages, losses, or expenses arising out of or relating to your use of the Website or violation of these Terms.',
    section7Title: '7. Governing Law',
    section7_1: '7.1. These Terms are governed by and construed in accordance with the laws of [insert jurisdiction], without regard to its conflict of laws principles.',
    section8Title: '8. Changes to Terms',
    section8_1: '8.1. We reserve the right to modify these Terms at any time. Any changes will be effective immediately upon posting on the Website. Your continued use of the Website after the posting of changes constitutes your acceptance of such changes.',
    section9Title: '9. Contact Us',
    section9_1: '9.1. If you have any questions about these Terms, please contact us at support@sai.com. By using the Website, you acknowledge that you have read, understood, and agree to be bound by these Terms.',
  },

  // Copy
  copy: {
    copiedToClipboard: 'Copied to clipboard',
    copyFailed: 'Copy failed',
  },

  // Errors
  errors: {
    networkError: 'Network error',
    pleaseSelectFilter: 'Please select the filter conditions',
    retry: 'Retry',
  },
}
